module.exports = __webpack_public_path__ + "static/rcep-featured-d55957fe6167ff2b4cceece115bb417a.png";